// SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
// Copyright (C) 2026 (original work) Open Assessment Technologies SA ;
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License

import config from '@/config';
import { getPermissionsGuard } from '@/core/guards/permissionsGuard';

export const routing = [
    {
        path: [config.routes.announcements.publish],
        guard: getPermissionsGuard([{ resource: 'portal.announcements', scopes: ['publish'] }]),
        controller: () => import('./controllers/myAnnouncements')
    },
    {
        path: [config.routes.announcements.list],
        controller: () => import('./controllers/announcements')
    },
    {
        path: [config.routes.announcements.new],
        guard: getPermissionsGuard([{ resource: 'portal.announcements', scopes: ['publish'] }]),
        controller: () => import('./controllers/myAnnouncement')
    },
    {
        path: [config.routes.announcements.edit],
        guard: getPermissionsGuard([{ resource: 'portal.announcements', scopes: ['publish'] }]),
        controller: () => import('./controllers/myAnnouncement')
    }
];
